// extracted by mini-css-extract-plugin
export var borderRadius = "_fu-4";
export var large = "_fu-3";
export var logoContainer = "_fu-0";
export var nameLogo = "_fu-2";
export var small = "_fu-1";